var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-button__container"},[(_vm.visible)?_c('el-button',{attrs:{"type":"text","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', true)}}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }